import React from 'react';
import { Box, Typography } from '@mui/material';
import { FieldProps } from 'framework/ui/field';

const TotalHeader = (props: FieldProps) => {
  return (
    <Box display="flex" justifyContent="end" pr={2.5} {...props}>
      <Typography fontWeight={800}>Total:</Typography>
    </Box>
  );
};
export default TotalHeader;
